/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PepsiCo Geospatial UAV API
 * OpenAPI spec version: 0.1.0
 */

export type TaskStatus = (typeof TaskStatus)[keyof typeof TaskStatus];

export const TaskStatus = {
  completed: "completed",
  failed: "failed",
  pending: "pending",
  processing: "processing",
  waiting: "waiting",
  superseded: "superseded",
} as const;
